import React from 'react';

import './Right.scss';

import Links from './Links/Links';
import { useLocation} from 'react-router-dom';
import PowerBi from './PowerBi/PowerBi';

const Right = () => {

   

  

    const location = useLocation();
    const All = ['/','/my-works','/team-works','/projects','/work-completed']
  
    if(!All.includes(location.pathname)){
     return null
    }
  

  return (

    <div className='rightm'>
   <PowerBi/>

    <Links/>
    </div>
  );
};

export default Right;
